<template>
  <div class="mzbox">
    <van-checkbox
      v-model="checked"
      @change="changeChecked"
      :checked-color="mainColor"
    >
      <template #default>
        <span style="font-size:12px;text-align: left;display: block;">注册参加本次展会及使用本平台，即视为您已充分理解并同意遵守我们的
        <a href="javascript:;" @click.stop="checkyhxy" style="color:rgb(18 132 239)">
          《用户协议》
        </a>、<a href="javascript:;" @click.stop="checksmyy" style="color:rgb(18 132 239)">
          《商贸邀约协议》
        </a>条款与条件以及同意展会<a href="javascript:;" @click.stop="checkys" style="color:rgb(18 132 239)">
          《隐私政策》
        </a>，同意参与「商贸配对」服务，并授权将本人联系信息用于供采商贸邀约对接服务。在此基础上，主办方或平台可能会向您推送精准定制资讯，涵盖展会相关动态、市场趋势洞察、供应及采购信息、产品资料、活动情报、采购优惠等内容，以助力您更好地规划和参与展会，拓展更多商业人脉，全方位提升参展体验和成交效率。</span>
      </template>
    </van-checkbox>
  </div>
  <div class="self-dia" v-show="showyhxy" @click="show = false">
    <div class="mz-block" @click.stop>
      <h3>用户协议</h3>
<p>
    <span style=";font-family:微软雅黑;font-size:14px"><span style="font-family:微软雅黑">生效日期</span>: 2025 年 1月 1日</span>
</p>
<p>
    <strong><span style="font-family: 微软雅黑;font-size: 14px">1. 引言</span></strong>
</p>
<p>
    <strong><span style="font-family: 微软雅黑;font-size: 14px">1.1 合同</span></strong>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px"><span style="font-family:微软雅黑">您同意，点击</span><span style="font-family:微软雅黑">“注册”或类似内容，注册、访问或使用我们的服务 (见下文)，即表示您同意与我们签订具有法律约束力的合同 (即使您是代表公司使用我们的“服务”也同样有效)。若您不同意本合同 (“合同”或“用户协议”)，请不要点击</span></span><span style=";font-family:微软雅黑;font-size:14px">“登录”、“快捷登录“、</span><span style=";font-family:微软雅黑;font-size:14px">“马上加入”或类似内容，也不要访问或以任何其他方式使用我们提供的任何“服务”。如果您希望终止本合同，您可以随时注销帐号并不再访问或使用我们的“服务”。</span>
</p>
<p>
    <strong><span style="font-family: 微软雅黑;font-size: 14px">服务</span></strong>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px">本合同适用于本合同项下提供网站、</span><span style=";font-family:微软雅黑;font-size:14px">小程序、</span><span style=";font-family:微软雅黑;font-size:14px"><span style="font-family:微软雅黑">通信和其他服务</span> (统称“服务”)，包括这些服务的站外数据收集，例如: 我们的广告服务和“通过我们申请”与“通过我们分享”插件。我们“服务”的注册用户即为“用户”，没有注册的用户即为“访客”。</span>
</p>
<p>
    <strong><span style="font-family: 微软雅黑;font-size: 14px">我们</span></strong>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px"><span style="font-family:微软雅黑">您将与我们</span> (也称为“我们”) 签订本合同。</span>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px"><span style="font-family:微软雅黑">作为我们</span><span style="font-family:微软雅黑">“服务”的访客或用户，对您个人信息的收集、使用和共享须遵守《隐私政策》和更新内容。</span></span>
</p>
<p>
    <strong><span style="font-family: 微软雅黑;font-size: 14px">1.2 用户和访客</span></strong>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px"><span style="font-family:微软雅黑">如果您注册或加入我们</span><span style="font-family:微软雅黑">“服务”，将会成为“用户”。如果您选择不注册我们“服务”，可作为“访客”访问某些功能。</span></span>
</p>
<p>
    <strong><span style="font-family: 微软雅黑;font-size: 14px">1.3 更改</span></strong>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px"><span style="font-family:微软雅黑">我们可能会不时修改本合同、我们的《隐私政策》。若有重大更改，我们会通过</span><span style="font-family:微软雅黑">“服务”或其他方式向您发出通知，使您有机会在更改生效之前查看更改。我们同意，修改内容不能追溯。若反对任何更改，您可注销帐号。在我们发布或发送关于条款更改的通知后，若您继续使用我们的“服务”，即表示自更改生效之日起，您同意更新后的条款。</span></span>
</p>
<p>
    <strong><span style="font-family: 微软雅黑;font-size: 14px">2. 义务</span></strong>
</p>
<p>
    <strong><span style="font-family: 微软雅黑;font-size: 14px">2.1 您的帐号</span></strong>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px"><span style="font-family:微软雅黑">用户为帐号持有人。您同意</span>: (1) 使用强密码并妥善保管它；(2) 不转移帐号的任何部分 (例如: 好友) 以及 (3) 遵守法律、我们规定的应做事项和禁止事项。除非您注销了帐号或举报了滥用情况，否则您对帐号上发生的所有事件负责。</span>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px"><span style="font-family:微软雅黑">您的帐号只属于您，不属于他人</span> (包括您的雇主在内)。然而，对于另一方购买给您使用的“服务”，支付此类“服务”费用的一方有权控制此类付费“服务”的访问并有权获得您的使用情况报告；但他们对您的个人帐号不享有任何权利。</span>
</p>
<p>
    <strong><span style="font-family: 微软雅黑;font-size: 14px">2.2 支付</span></strong>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px"><span style="font-family:微软雅黑">若您购买我们的任何付费服务</span> (“</span><span style=";font-family:微软雅黑;font-size:14px">P</span><span style=";font-family:微软雅黑;font-size:14px">LUS会员服务”</span><span style=";font-family:微软雅黑;font-size:14px"><span style="font-family:微软雅黑">、</span><span style="font-family:微软雅黑">“短信营销服务”、“广告服务”、“赞助服务”等</span></span><span style=";font-family:微软雅黑;font-size:14px">)，则表示您同意向我们支付相应费用和税费并同意付费服务适用的附加条款。未支付此等费用将导致付费服务终止。此外，您同意:</span>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px">● 即便在您的支付方式 (如信用卡) 过期之后，我们仍可储存和继续使用其信息，以避免“服务”的中断并用来支付您可能会购买的其他“服务”。</span>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px">● 如果您购买了会员服务，会在每个使用期开始时通过您的支付方式扣除该时期对应的费用和税费。请在续费日期前取消方案，以避免将来继续扣取费用。了解如何取消或暂停高级帐号服务。</span>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px">● 所有“服务”的购买均需遵守我们《退款政策》。</span>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px">● 我们会根据您购买时提供的账单信息计算您应支付的税费。</span>
</p>
<p>
    <strong><span style="font-family: 微软雅黑;font-size: 14px">2.3 通知及服务信息</span></strong>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px"><span style="font-family:微软雅黑">您同意我们通过以下方式向您发出通知</span>: (1) 在“服务”中通知，或 (2) 发消息到您提供的联系方式，如邮箱、手机号码、邮寄地址等。您同意及时更新您的联系方式。</span>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px">请</span><span style=";font-family:微软雅黑;font-size:14px">通过退订或通过</span><span style=";font-family:微软雅黑;font-size:14px">设置</span><span style=";font-family:微软雅黑;font-size:14px">，</span><span style=";font-family:微软雅黑;font-size:14px">以便控制和限制来自我们的消息。</span>
</p>
<p>
    <strong><span style="font-family: 微软雅黑;font-size: 14px">3. 权利和限制</span></strong>
</p>
<p>
    <strong><span style="font-family: 微软雅黑;font-size: 14px">3.1. 您授予我们的权限</span></strong>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px"><span style="font-family:微软雅黑">全球性、可转让、可再授权、无须取得您和他人同意、无需另行通知或为您或他人提供报酬，即可使用、复制、修改、传播、发表、加工您通过我们</span><span style="font-family:微软雅黑">“服务”提供的信息和内容的权利。这些权利受到以下限制:</span></span>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px">1、 您可以通过删除“服务”里的特定内容或注销帐号，来终止您授予我们的权限，但是 (a) 您与他人分享了该内容并且他们复制、重新分享或保存了该内容的情况除外，且 (b) 从备份和其他系统中删除内容将需要一段时间。</span>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px">2、 除非取得您的同意，否则我们不会将您的内容包含在发送给他人的第三方产品和服务的广告中 (包括推广内容)。但是，我们有权在您的内容和信息旁边发布广告，并且不需要向您或他人提供报酬；同时，根据《隐私政策》所述，您进行的社交操作可能是可见的并且会被用于广告中。如果您使用“服务”的某项功能，我们可能会在提及这项功能的时候使用您的姓名或照片，以便在我们的“服务”内推广这项功能，但是会在您的设置允许范围内进行。</span>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px">3、 如果我们想授权第三方在“服务”范围之外发布您的内容，须取得您的同意。但是，如果您选择将您的动态“公开”，我们将启用一项功能，允许用户将您的公开动态嵌入第三方服务，还将允许搜索引擎通过其服务将这些公开内容作为可被查找的内容。了解更多</span>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px">4、 我们可能会在征得您同意后编辑和更改内容格式 (如进行翻译或转录，修改大小、排版或文件类型，或删除元数据)，但是我们不会更改您所表达的意思。</span>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px">5、 因为您对个人内容和信息拥有所有权，而我们对其只有非专属权利，所以您可以将内容和信息提供给他人，包括在知识共享 (Creative Commons) 许可所允许的范围内。</span>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px"><span style="font-family:微软雅黑">您和我们同意，我们能访问、保存、处理和使用您提供的任何信息和个人数据，前提是遵守《隐私政策》的条款以及您的选择</span> (包括设置)。</span>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px"><span style="font-family:微软雅黑">通过向我们提交关于我们</span><span style="font-family:微软雅黑">“服务”的建议或其他反馈意见，您同意我们可以 (但非必须) 出于任何目的使用和分享此等反馈意见，并且无需向您提供报酬。</span></span>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px"><span style="font-family:微软雅黑">您同意仅提供不触犯法律和不侵犯他人权利</span> (包括知识产权) 的内容或信息。您也同意，您的档案信息是真实的。在某些国家/地区，我们可能会依照当地法律删除某些内容。</span>
</p>
<p>
    <strong><span style="font-family: 微软雅黑;font-size: 14px">3.2 服务可用性</span></strong>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px"><span style="font-family:微软雅黑">我们可能会修改、暂停或取消任何</span><span style="font-family:微软雅黑">“服务”。我们还可能在法律允许的范围内修改价格，此类修改将在发出合理通知后生效。</span></span>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px">我们不承诺存储或持续展示您发布的任何信息和内容。我们不是提供存储服务的网站。您同意，除非适用法律和我们《隐私政策》规定，否则我们没有义务存储、维护或向您提供您或他人所提供的任何内容或信息的副本。</span>
</p>
<p>
    <strong><span style="font-family: 微软雅黑;font-size: 14px">3.3 限制</span></strong>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px"><span style="font-family:微软雅黑">我们保留限制您使用</span><span style="font-family:微软雅黑">“服务”的权利，包括限制您的我们好友数量和您与其他用户互动的能力。如果您违反了本合同或法律，或对“服务”使用不当 ，我们将保留限制、暂停或终止您帐号的权利。</span></span>
</p>
<p>
    <strong><span style="font-family: 微软雅黑;font-size: 14px">3.4 知识产权</span></strong>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px"><span style="font-family:微软雅黑">我们保留</span><span style="font-family:微软雅黑">“服务”中的所有知识产权。与“服务”相关的商标和标志是其各自所有者的商标。</span></span>
</p>
<p>
    <strong><span style="font-family: 微软雅黑;font-size: 14px">3.5 自动化处理</span></strong>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px">我们使用您提供的信息和数据，以及我们拥有的用户信息和数据，提供人脉、内容和功能等实用建议。</span>
</p>
<p>
    <strong><span style="font-family: 微软雅黑;font-size: 14px">4. 免责声明和有限责任</span></strong>
</p>
<p>
    <strong><span style="font-family: 微软雅黑;font-size: 14px">4.1 无担保</span></strong>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px"><span style="font-family:微软雅黑">我们及其关联公司不对服务作任何声明或保证，包括不作关于不间断或无出错服务的声明，并且根据</span><span style="font-family:微软雅黑">“现成状态”和“可获得性”提供“服务” (包括内容和信息)。在适用法律允许的最大范围内，我们及其关联公司对任何暗示或法定担保概不负责，包括任何对所有权、数据的准确性、不侵权、适销性或特定用途的适用性的暗示担保。</span></span>
</p>
<p>
    <strong><span style="font-family: 微软雅黑;font-size: 14px">4.2 责任免除</span></strong>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px"><span style="font-family:微软雅黑">除非我们已签订另一份独立书面协议取代本合同，否则在法律允许的最大范围内，我们，包括其关联公司，不因与此合同相关的利润、商业机会、名誉</span> (例如: 攻击性或诽谤性声明) 、数据 (例如: 业务过少或损失，使用或修改您的信息或内容) 损失或任何间接的、突发的、后续的、特殊的或惩罚性的损失承担责任。</span>
</p>
<p>
    <strong><span style="font-family: 微软雅黑;font-size: 14px">4.3 协议基础排除条件</span></strong>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px"><span style="font-family:微软雅黑">即使我们或其关联公司已被告知类似损失的可能性，或者这些补救措施没有取得成效，第</span> 4 节中的责任限制是您与我们协议基础的一部分，且对所有索赔适用 (例如: 担保、侵权、疏忽、合同和法律)。</span>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px"><span style="font-family:微软雅黑">此类责任限制不适用于死亡或人身伤害的责任，或欺诈、重大过失或故意不当行为的责任，或以下情况中的责任</span>: 违反某项实质性义务、某项实质性义务作为服务交付的先决条件以及您可对其合理依赖，但是仅限于违约直接导致损失且订立合同时该损失可以预见以及就本合同而言该损失较典型的情况。</span>
</p>
<p>
    <strong><span style="font-family: 微软雅黑;font-size: 14px">5. 终止</span></strong>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px"><span style="font-family:微软雅黑">我们或您均可在任何时间通知对方终止本合同。一旦协议终止，您就失去了访问或使用</span><span style="font-family:微软雅黑">“服务”的权利。以下内容将不会终止:</span></span>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px">● 我们使用和公开您反馈意见的权利；</span>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px">● 用户和/或访客对您通过“服务”分享的内容和信息进行转发的权利；</span>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px">● 您可以</span><span style=";font-family:微软雅黑;font-size:14px">删除程序来终止服务</span><span style=";font-family:微软雅黑;font-size:14px">。</span>
</p>
<p>
    <strong><span style="font-family: 微软雅黑;font-size: 14px">6. 通用条款</span></strong>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px">如果对本合同有管辖权的法院发现协议中有任何部分无法执行，双方均同意，该法院应修改条款，在保留该条款目的的情况下，令该部分得以执行。如果法院无法做到这一点，双方同意让法院删除无法执行的部分，并且执行本合同的其他所有内容。</span>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px"><span style="font-family:微软雅黑">本合同</span> (包括您使用“服务”某一功能时我们可能提供的附加条款) 是我们双方关于“服务”的唯一协议，将取代关于“服务”的所有先前协议。</span>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px"><span style="font-family:微软雅黑">假如我们不对违反本合同的行为采取行动，并不表示我们放弃了执行本合同的权利。您不得在没有取得我们同意的情况下将本合同</span> (包括您的用户身份或“服务”使用权) 转让或移交给任何人。但是，您同意我们可以在没有取得您同意的情况下将本合同转让给关联公司或我们的</span><span style=";font-family:微软雅黑;font-size:14px">合作</span><span style=";font-family:微软雅黑;font-size:14px">方</span><span style=";font-family:微软雅黑;font-size:14px">、收购方</span><span style=";font-family:微软雅黑;font-size:14px">。本合同不存在第三方受益者。</span>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px">&nbsp;</span>
</p>
<p>
    <strong><span style="font-family: 微软雅黑;font-size: 14px">7. 我们的“应做事项”和“禁止事项”</span></strong>
</p>
<p>
    <strong><span style="font-family: 微软雅黑;font-size: 14px">7.1. 应做事项</span></strong>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px"><span style="font-family:微软雅黑">您同意，您将</span>:</span>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px">1、 遵守所有适用法律，包括但不限于隐私权法律、知识产权法、反垃圾邮件法、税法以及监管要求；</span>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px">2、 提供准确信息，并及时更新信息；</span>
</p>
<p>
    <strong><span style="font-family: 微软雅黑;font-size: 14px">7.2. 禁止事项</span></strong>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px"><span style="font-family:微软雅黑">您同意，您将不会</span>:</span>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px">1、 开发、支持或使用软件、设备、脚本、自动程序或其他任何方法或手段 (包括爬虫、浏览器插件和附加组件或其他任何技术) 对“服务”数据进行采集或复制“服务”中的职业档案等其他信息；</span>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px">2、 覆盖“服务”的任何安全功能，或绕过或规避“服务”的任何访问控制或服务使用限制 (例如: 关键词搜索或档案浏览次数上限)；</span>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px">3、 未经我们同意，复制、使用、公开或传播任何通过“服务”获得的信息，无论是直接获得还是通过第三方 (例如: 搜索引擎) 获得的；</span>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px">4、 公开您无权公开的信息，例如: 他人的保密信息，包括您雇主的信息；</span>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px">5、 违反他人知识产权，包括版权、专利、商标、商业秘密或其他专有权利。例如: 未经他人允许，不得复制或传播 (除非通过可用的分享功能) 他人的文章或内容。他人可能在知识共享许可下发布文章和内容，表明允许复制或传播；</span>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px">6、 侵犯我们的知识产权或其他权利，包括但不限于 (i) 复制或传播我们的教育视频或其他材料；或 (ii) 复制或传播我们的技术，除非是在开源许可下发布的技术; (iii) 在任何商业名称、邮箱或网址中使用“我们”一词或我们的标志，《品牌塑造准则》中提到的情况除外；</span>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px">7、 发布含有软件病毒、蠕虫病毒或其他有害代码的内容；</span>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px">8、 逆向工程、反编译、反汇编、破译或试图得出“服务”或任何相关非开源技术的源码；</span>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px">9、 未经我们明确同意，暗示或声明您隶属我们或受我们认可，例如: 声称自己是我们认证的培训师；</span>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px">10、 未经我们同意，租用、租赁、出借、交易、出售/转售或以其他方式从“服务”或相关数据中获利，或获取相关数据;</span>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px">11、 未经我们同意，以宣传您的我们档案或某个我们群组以外的任何目的，深层链接到“服务”；</span>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px">12、 使用自动程序 (即“bots”) 或其他自动方法访问“服务”、添加或下载通讯录、发送或重定向消息；</span>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px">13、 以任何竞争目的监控“服务”的可用性、性能或功能；</span>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px">14、 参与“建立构架”、“制作镜像”或其他模拟“服务”外观或功能的活动；</span>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px">15、 覆盖或以其他方式修改“服务”或其外观 (例如: 在服务中插入元素或移除、覆盖或遮盖服务中包含的广告)；</span>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px">16、 干扰“服务”的运营、或给“服务”带来不合理的负荷 (例如: 群发邮件、拒绝服务攻击、病毒、游戏运算)；和/或</span>
</p>
<p>
    <strong><span style="font-family: 微软雅黑;font-size: 14px">8. 关于内容的投诉</span></strong>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px">我们尊重他人的知识产权。我们要求用户发布准确无误的信息，且不侵犯第三方的知识产权和其他权利。我们为关于我们用户发布内容的投诉提供政策和法律程序。</span>
</p>
<p>
    <strong><span style="font-family: 微软雅黑;font-size: 14px">9. 如何联系我们</span></strong>
</p>
<p>
    <span style=";font-family:微软雅黑;font-size:14px">如需咨询常见问题，您可在线联系我们。</span>
</p>
<p>
    <br/>
</p>
      <div class="btn-box">
        <van-button type="primary" :color="mainColor" @click="hideMz"
          >确定</van-button
        >
      </div>
    </div>
  </div>
  <div class="self-dia" v-show="showxmyy" @click="show = false">
    <div class="mz-block" @click.stop>
      <h3>CIHC 中国氢能产业供需链接平台商贸配对服务授权与规则协议</h3>
<p>
    <span style="font-family: 微软雅黑;font-size: 14px"><span style="font-family:微软雅黑">发布日期：</span>2025 年 10 月 30 日</span>
</p>
<p>
    <strong><span style="font-family: 微软雅黑;font-size: 14px">一、服务宗旨</span></strong>
</p>
<p>
    <span style="font-family: 微软雅黑;font-size: 14px">CIHC 中国氢能产业供需链接平台（以下简称 &quot;平台&quot;）致力于赋能供应链效能，链动全球贸易对接，为用户提供专业的线上线下智能营销方案及精准的供需对接服务，助力用户实现获客增长与商贸合作达成。</span>
</p>
<p>
    <strong><span style="font-family: 微软雅黑;font-size: 14px">二、服务内容</span></strong>
</p>
<p>
    <span style="font-family: 微软雅黑;font-size: 14px"><span style="font-family:微软雅黑">平台</span> &quot;商贸配对服务&quot; 基于用户提交的需求信息、经营范畴等数据，通过数智化技术筛选匹配的供应商 / 采购商资源，为用户提供商贸洽谈对接支持，包括但不限于匹配信息推送、合作机会推荐、线上沟通通道搭建等。</span>
</p>
<p>
    <strong><span style="font-family: 微软雅黑;font-size: 14px">三、用户授权说明</span></strong>
</p>
<p>
    <span style="font-family: 微软雅黑;font-size: 14px"><span style="font-family:微软雅黑">本人自愿申请参与</span> CIHC 中国氢能产业供需链接平台 &quot;商贸配对服务&quot;，并明确授权平台将本人联系信息（包括但不限于姓名 / 企业名称、联系电话、电子邮箱、经营地址、业务范畴等）分享至平台筛选的匹配合作方，仅用于双方商贸配对沟通。</span>
</p>
<p>
    <span style="font-family: 微软雅黑;font-size: 14px"><span style="font-family:微软雅黑">本人同意平台按照《用户协议》《隐私政策》约定，收集、整理、存储本人提交的个人</span> / 企业资料（含名片信息、经营资质、需求偏好等），并用于以下用途：（1）优化商贸配对算法，提升匹配精准度；（2）促成本人与潜在 / 既存合作方的名片交换及商贸沟通；（3）在平台内合规展示本人供需信息（如优质用户推荐、需求发布等）；（4）推送平台相关的行业动态、合作机会等营销服务；（5）其他符合法律法规及平台规则的商贸对接用途。</span>
</p>
<p>
    <strong><span style="font-family: 微软雅黑;font-size: 14px">四、用户确认与承诺</span></strong>
</p>
<p>
    <span style="font-family: 微软雅黑;font-size: 14px">本人已详细阅读、充分理解并同意平台《商贸配对服务规则及条款》《用户协议》《隐私政策》的全部内容，知晓个人资料的收集、使用、存储及展示范围。</span>
</p>
<p>
    <span style="font-family: 微软雅黑;font-size: 14px"><span style="font-family:微软雅黑">本人承诺所提交的个人</span> / 企业信息、需求信息真实、准确、完整，无虚假记载、误导性陈述或重大遗漏；若因信息不实导致自身或第三方损失，由本人自行承担责任。</span>
</p>
<p>
    <span style="font-family: 微软雅黑;font-size: 14px">本人将遵守平台规则及合作方合法权益，不利用商贸配对服务从事欺诈、违法违规等行为；在平台发布内容真实合法合规，不违反广告法、促销法等相关法规的规定，若联系方式、需求信息发生变更，将及时在平台更新，确保服务准确性。</span>
</p>
<p>
    <strong><span style="font-family: 微软雅黑;font-size: 14px">五、平台责任说明</span></strong>
</p>
<p>
    <span style="font-family: 微软雅黑;font-size: 14px">平台将按照本规则及相关协议约定提供商贸配对服务，尽力保障匹配资源的相关性与合规性，严格遵守《隐私政策》保护用户资料安全，不向无关第三方泄露（匹配合作方除外）。</span>
</p>
<p>
    <span style="font-family: 微软雅黑;font-size: 14px">平台有权根据运营需要调整服务规则，调整后将通过平台公告、站内信等方式通知用户；用户继续使用服务即视为同意调整后的规则。</span>
</p>
<p>
    <span style="font-family: 微软雅黑;font-size: 14px">平台仅提供信息对接服务，不参与用户与合作方的具体商贸洽谈及合同签订，不对合作方资质、信誉、履约能力作实质性担保，用户需自行核实合作方信息并承担合作风险。</span>
</p>
<p>
    <strong><span style="font-family: 微软雅黑;font-size: 14px">六、其他说明</span></strong>
</p>
<p>
    <span style="font-family: 微软雅黑;font-size: 14px">本规则未尽事宜，按照平台《用户协议》《隐私政策》及相关规则执行。</span>
</p>
<p>
    <span style="font-family: 微软雅黑;font-size: 14px"><span style="font-family:微软雅黑">若用户对本规则有疑问，可通过平台官方客服（</span>13810803012 /liuyi19823127@163.com）咨询；</span>
</p>
<p>
    <span style="font-family: 微软雅黑;font-size: 14px">因本服务产生的争议，平台将与用户协商解决，协商不成的，按照《用户协议》争议解决条款处理。</span>
</p>
<p>
    <span style="font-family: 微软雅黑;font-size: 14px"><span style="font-family:微软雅黑">【</span>CIHC 中国氢能产业供需链接平台运营主体】</span>
</p>
<p>
    <br/>
</p>
      <div class="btn-box">
        <van-button type="primary" :color="mainColor" @click="hideMz"
          >确定</van-button
        >
      </div>
    </div>
  </div>
  <div class="self-dia" v-show="showyx" @click="show = false">
    <div class="mz-block" @click.stop>
      <h3>隐私政策</h3>

<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">更新日期：</span><span style="font-family:宋体">202</span></span><span style="font-family: 宋体;font-size: 14px">5</span><span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">年</span> </span><span style="font-family: 宋体;font-size: 14px">1</span><span style="font-family: 宋体;font-size: 14px">&nbsp;<span style="font-family:宋体">月</span> <span style="font-family:宋体">1 日</span></span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">生效日期：</span><span style="font-family:宋体">202</span></span><span style="font-family: 宋体;font-size: 14px">5</span><span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">年</span> </span><span style="font-family: 宋体;font-size: 14px">1</span><span style="font-family: 宋体;font-size: 14px">&nbsp;<span style="font-family:宋体">月</span> </span><span style="font-family: 宋体;font-size: 14px">2</span><span style="font-family: 宋体;font-size: 14px">&nbsp;<span style="font-family:宋体">日</span></span>
</p>
<p style="margin-top:0;margin-bottom:20px;line-height:30px;background:rgb(255,255,255)">
    <span style="font-family: 宋体;font-size: 14px">&nbsp;我们</span><span style="font-family: 宋体;font-size: 14px">非常重视您的隐私权。您提供的任何个人信息，只会按照本隐私政策进行处理。</span>
</p>
<p style="margin-top:0;margin-bottom:20px;line-height:30px;background:rgb(255,255,255)">
    <strong><span style="text-decoration:underline;"><span style="font-family: 宋体;font-size: 14px">本隐私政策适用于您使用应用程序和线上线下的服务。</span></span></strong><span style="font-family: 宋体;font-size: 14px">我们希望通过本隐私政策向您说明我们在您使用我们的服务时如何收集、使用、保存、共享和转移这些信息，以及我们为您提供的访问、更新、删除和保护这些信息的方式。</span>
</p>
<p style="margin-top:0;margin-bottom:20px;line-height:30px;background:rgb(255,255,255)">
    <span style="font-family: 宋体;font-size: 14px">超链接与其他网站链接给您提供诸多方便。点击超链接后，您将会离开我们的网站并可能被引导到另一个不属于我们控制的网站，我们的隐私政策无法运用于该不受我们控制的网站。请参考该等网站的相关隐私政策。</span>
</p>
<p style="margin-top:0;margin-bottom:20px;line-height:30px;background:rgb(255,255,255)">
    <strong><span style="text-decoration:underline;"><span style="font-family: 宋体;font-size: 14px">如果您不希望您的个人信息按照本政策中所描述的方式使用，请停止使用我们的应用程序或服务。如您继续使用我们的应用程序或服务将视为您充分理解并同意本隐私政策的内容。</span></span></strong>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">本隐私政策将帮助您了解：</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">（</span><span style="font-family:宋体">1）</span></span><strong><span style="font-family: 宋体;font-size: 14px;background: rgb(255, 255, 255)"><span style="font-family:宋体">当您填写申请表或注册表参观展览或</span></span></strong><strong><span style="font-family: 宋体;font-size: 14px;background: rgb(255, 255, 255)"><span style="font-family:宋体">登录</span><span style="font-family:宋体">CIHC中国氢能产业供需链接平台&nbsp;“以下简称为小程序”</span></span></strong><strong><span style="font-family: 宋体;font-size: 14px;background: rgb(255, 255, 255)"><span style="font-family:宋体">时，</span></span></strong><strong><span style="font-family: 宋体;font-size: 14px;background: rgb(255, 255, 255)"><span style="font-family:宋体">为了向阁下提供优质的服务</span></span></strong><strong><span style="font-family: 宋体;font-size: 14px;background: rgb(255, 255, 255)"><span style="font-family:宋体">我们将收集您的个人信息。</span></span></strong><strong><span style="font-family: 宋体;font-size: 14px;background: rgb(255, 255, 255)"><span style="font-family:宋体">本公司可能会在阁下向本公司办理登记手续、使用本公司的服务、出席本公司的活动或与本公司通讯时收集资料</span><span style="font-family:宋体">(例如公司名称、</span></span></strong><strong><span style="font-family: 宋体;font-size: 14px;background: rgb(255, 255, 255)"><span style="font-family:宋体">姓名、身份证号</span></span></strong><strong><span style="font-family: 宋体;font-size: 14px">码</span></strong><strong><span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">、联络人、地址、电话、移动电话、传真号码、电邮地址、网址、业务性质、产品／服务细节等</span><span style="font-family:宋体">)时，收集贵公司或贵公司员工的资料。</span></span></strong><strong><span style="font-family: 宋体;font-size: 14px;background: rgb(255, 255, 255)"><span style="font-family:宋体">如您代表企业</span>/组织申请参加展会，您提供给我们的信息可能还包括</span></strong><strong><span style="font-family: 宋体;font-size: 14px;background: rgb(255, 255, 255)"><span style="font-family:宋体">企业</span>/组织名称、</span></strong><strong><span style="font-family: 宋体;font-size: 14px;background: rgb(255, 255, 255)"><span style="font-family:宋体">公司业务性质、公司网址、宣传视频、直播、商城链接、</span></span></strong><strong><span style="font-family: 宋体;font-size: 14px;background: rgb(255, 255, 255)"><span style="font-family:宋体">营业执照、联系地址、产品类型等。</span></span></strong><strong><span style="font-family: 宋体;font-size: 14px">此外，本公司会在提供服务、产品的过程中或在其他相关情况下，收集人员的个人信息。</span></strong>
</p>
<p style="line-height: 26px;background: rgb(255, 255, 255)">
    <span style="font-family: 宋体;font-size: 14px">如未能按要求提供本公司所要求的资料，本公司可能无法为阁下提供所需服务。</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">（</span><span style="font-family:宋体">2）在您进行注册认证、发布信息、互动交流或使用基于地理位置的服务时，基于法律要求或实现功能所必须，我们可能会收集公司、姓名、业务性质、联络方式、通讯录、音视频文件、地理位置等个人敏感信息。您有权拒绝向我们提供这些信息，或者撤回您对这些信息的授权同意。请您了解，拒绝或撤回授权同意，将导致您无法使用相关的特定功能，但不影响您使用“小程序”、“P</span></span><span style="font-family: 宋体;font-size: 14px">C</span><span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">数智服务平台</span><span style="font-family:宋体">”的其他功能；</span></span>
</p>
<p style="margin-bottom: 20px;line-height: 30px;background: rgb(255, 255, 255)">
    <span style="font-family: 宋体;font-size: 14px">以下情形中，收集、使用您的个人信息无需事先征得您的授权同意：</span>
</p>
<p style="margin-top: 7px;margin-bottom: 7px;margin-left: 48px;line-height: 30px;background: rgb(255, 255, 255)">
    <span style="font-family: Symbol;font-size: 13px">·&nbsp;</span><span style="font-family: 宋体;font-size: 14px">与</span><span style="font-family: 宋体;font-size: 14px">我方</span><span style="font-family: 宋体;font-size: 14px">履行法律法规规定的职责或义务相关；</span>
</p>
<p style="margin-top: 7px;margin-bottom: 7px;margin-left: 48px;line-height: 30px;background: rgb(255, 255, 255)">
    <span style="font-family: Symbol;font-size: 13px">·&nbsp;</span><span style="font-family: 宋体;font-size: 14px">与国家安全、国防安全有关；</span>
</p>
<p style="margin-top: 7px;margin-bottom: 7px;margin-left: 48px;line-height: 30px;background: rgb(255, 255, 255)">
    <span style="font-family: Symbol;font-size: 13px">·&nbsp;</span><span style="font-family: 宋体;font-size: 14px">与公共安全、公共卫生、重大公共利益有关；</span>
</p>
<p style="margin-top: 7px;margin-bottom: 7px;margin-left: 48px;line-height: 30px;background: rgb(255, 255, 255)">
    <span style="font-family: Symbol;font-size: 13px">·&nbsp;</span><span style="font-family: 宋体;font-size: 14px">与犯罪侦查、起诉、审判和判决执行等有关；</span>
</p>
<p style="margin-top: 7px;margin-bottom: 7px;margin-left: 48px;line-height: 30px;background: rgb(255, 255, 255)">
    <span style="font-family: Symbol;font-size: 13px">·&nbsp;</span><span style="font-family: 宋体;font-size: 14px">为应对突发公共卫生事件，或者紧急情况下为保护您或其他人的生命健康和财产安全所必需；</span>
</p>
<p style="margin-top: 7px;margin-bottom: 7px;margin-left: 48px;line-height: 30px;background: rgb(255, 255, 255)">
    <span style="font-family: Symbol;font-size: 13px">·&nbsp;</span><span style="font-family: 宋体;font-size: 14px">您自行向社会公众公开的个人信息；</span>
</p>
<p style="margin-top: 7px;margin-bottom: 7px;margin-left: 48px;line-height: 30px;background: rgb(255, 255, 255)">
    <span style="font-family: Symbol;font-size: 13px">·&nbsp;</span><span style="font-family: 宋体;font-size: 14px">根据您的要求签订和履行合同所必需的信息；</span>
</p>
<p style="margin-top: 7px;margin-bottom: 7px;margin-left: 48px;line-height: 30px;background: rgb(255, 255, 255)">
    <span style="font-family: Symbol;font-size: 13px">·&nbsp;</span><span style="font-family: 宋体;font-size: 14px">从合法公开来源中收集个人信息，包括但不限于合法的新闻报道、政府信息公开等渠道；</span>
</p>
<p style="margin-top: 7px;margin-bottom: 7px;margin-left: 48px;line-height: 30px;background: rgb(255, 255, 255)">
    <span style="font-family: Symbol;font-size: 13px">·&nbsp;</span><span style="font-family: 宋体;font-size: 14px">维护所提供产品或服务的安全稳定运行所必需的，如识别、修正产品或服务故障</span><span style="font-family: 宋体;font-size: 14px">。</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">（</span><span style="font-family:宋体">3）我们会将在境内运营过程中收集和产生的您的个人信息存储于中华人民共和国境内，并不会将上述信息传输至境外。我们仅会在为提供“小程序”及商贸对接等平台服务之目的所必需的期间内保留您的个人信息；</span></span>
</p>

<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">（</span><span style="font-family:宋体">4）我们不会向第三方共享、提供、转让或者从第三方获取您的个人信息，除非经过您的同意；</span></span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">（</span>5）我们将努力采取合理的安全措施来保护您的个人信息。我们将采用行业内通行的方式及尽最大的商业努力来保护您个人敏感信息的安全；</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">（</span>6） “小程序”会基于算法等人工智能决策机制，推送您可能感兴趣的信息</span><span style="font-family: 宋体;font-size: 14px">和资讯，并通过短信、邮件、呼叫中心和站内提醒，让您不错过重要消息和商机</span><span style="font-family: 宋体;font-size: 14px">；</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">如您未明示同意本隐私政策并开始使用，我们将仅收集浏览推荐所必需的信息，这将导致我们无法为您提供完整的产品和服务，但我们同样会采用去标识化、加密等措施来保护这些信息。如果您不同意本隐私政策，我们无法为您提供完整的产品和服务，您也可以选择停止使用。当您选择继续或再次使用时，基于提供产品和服务所必需，将视为您接受和认可我们按照本政策对您的相关信息进行处理。</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">小程序（以下简称</span><span style="font-family:宋体">“我们”）深知个人信息对您的重要性，我们将按照法律法规的规定，采用安全的保护措施，保护您的个人信息及隐私安全。因此，我们制定本“隐私政策”并特别提示：希望您在使用“小程序”及相关服务前仔细阅读并理解本隐私政策，您可以按照指引作出您的适当选择。</span></span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">我们希望通过本隐私政策向您说明在您在使用</span> <span style="font-family:宋体">“小程序”软件及相关服务时，我们将按照本隐私政策收集、使用、存储、共享、转让及保护您的个人信息，向您介绍我们对您个人信息的处理，以及我们为您提供的查询、访问、删除、更正、撤回授权同意和保护这些信息的方式。其中，有关您个人信息权益的条款等重要内容我们已用加粗形式提示，请特别关注。</span></span>
</p>
<p>
    <strong><span style="font-family: 宋体;font-size: 14px">本人同意本协议，即表示同意参与「商贸配对」服务，并授权将本人联系信息分享至匹配供应商以进行配对。本人确认已阅读及明白，并同意「</span></strong><strong><span style="font-family: 宋体;font-size: 14px">CIHC</span></strong><strong><span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">中国氢能产业供需链接平台」</span><span style="font-family:宋体">“小程序” 商贸配对服务相关规则及条款，并同意《用户协议》和《隐私政策》所概述的收集及使用本人的个人资料，包括使用及提供本人的个人资料以供营销、商贸配对、名片交换、将您的联系方式用于供采双方之间在线商洽、邀约确认等用途。</span></span></strong>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">本隐私政策将帮助您了解以下内容：</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">一、我们如何收集和使用个人信息</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">二、我们对</span> Cookie 和同类技术的使用</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">三、我们如何存储个人信息</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">四、我们如何共享、转让、公开披露个人信息</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">五、我们如何保护个人信息的安全</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">六、您的权利</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">七、未成年人使用条款</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">八、隐私政策的修订和通知</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">九、适用范围</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">十</span><span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">、</span> <span style="font-family:宋体">其他</span></span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">一、我们如何收集和使用个人信息</span>
</p>
<p style="line-height: 26px">
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">在您使用</span><span style="font-family:宋体">“小程序”及服务的过程中，我们将根据合法、正当、必要的原则，收集信息。为了向阁下提供优质的服务，本公司可能会在阁下向本公司办理登记手续、使用本公司的服务、出席本公司的活动或与本公司通讯时收集资料(例如公司名称、联络人、地址、电话、</span></span><span style="font-family: 宋体;font-size: 14px">移动</span><span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">电话、传真号码、电邮地址、网址、业务性质、产品／服务细节等</span>)时，收集贵公司或贵公司员工的资料。此外，本公司会在提供服务、产品的过程中或在其他相关情况下，收集人员的个人信息。</span>
</p>
<p style="line-height: 26px">
    <span style="font-family: 宋体;font-size: 14px">如未能按要求提供本公司所要求的资料，本公司可能无法为阁下提供所需服务。</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">我们收集或请您提供的信息将用于：</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">1.保障产品的正常基础运行；</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">2.实现各项功能和服务；</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">3.优化、改善产品和服务；</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">4.保障产品、服务以及用户使用安全；</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">5.遵循法律法规与国家标准的规定。</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">（一）我们主动收集与使用的个人信息</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">我们会按照如下方式收集您在使用服务时主动提供的，以及您在使用功能或接受服务过程中产生的信息：</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">1.保障“小程序”和相关服务的正常运行</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">当您使用</span><span style="font-family:宋体">“小程序”及相关服务时，为了保障软件与服务的正常运行，我们会收集您的硬件型号、操作系统版本号、国际移动设备识别码（IMEI）、网络设备硬件地址（MAC）、IP 地址、软件版本号、网络接入方式及类型、操作日志等信息。请您了解，这些信息是我们提供服务和保障产品正常运行所必须收集的基本信息。</span></span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">2.注册、认证、登录“小程序”和相关服务</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">（</span>1） 当您注册、登录“小程序”及相关服务时，您可以通过手机号创建账号，我们将通过发送短信验证码来验证您的身份是否有效，并且您可完善相关的网络身份识别信息（如头像、昵称和密码），收集这些信息是为了帮助您完成注册。您还可根据自身需求选择填写性别、生日、地区</span><span style="font-family: 宋体;font-size: 14px">、</span><span style="font-family: 宋体;font-size: 14px">介绍</span><span style="font-family: 宋体;font-size: 14px">、动态</span><span style="font-family: 宋体;font-size: 14px">等信息完善您的个人信息。为您提供信息互动等服务</span><span style="font-family: 宋体;font-size: 14px">，</span><span style="font-family: 宋体;font-size: 14px">我们将非常重视用户隐私保护及确保信息安全。您进行观众登记参会或使用小程序平台服务，即表示您同意我们收集和使用您的位置等相关信息，为您提供服务。</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">（</span>2）在您使用“小程序认证”等需进行身份认证的功能或服务时，根据中华人民共和国相关法律法规，您可能需要提供您的真实身份信息（真实姓名、身份证号码、电话号码等）以完成实名验证。这些信息属于个人敏感信息，我们将采用行业内通行的方式，尽最大的商业努力来保护您个人敏感信息的安全。如果您不提供这些信息，您将可能无法获得相关服务，但不影响“小程序”其他功能与服务的正常使用。</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">3.为您推荐个性化的信息或服务</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">个性化推荐是</span><span style="font-family:宋体">“小程序”最基础、最核心的功能之一。 为实现这一功能，我们可能会收集并使用下列信息：</span></span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">（</span>1）关注、收藏、搜索、浏览偏好等您的操作、使用行为信息；</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">（</span>2）反馈、发布、点赞、评论等您主动提供的信息；</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">请您了解，我们收集、使用的上述信息进行了去标识化处理，数据分析仅对应特定的、无法直接关联用户身份的编码，无法也绝不会与您的真实身份相关联。</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">4.为您提供信息发布功能或服务</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">您发布内容、评论、提问或回答时，我们将收集您发布的信息，并展示您的昵称、头像、发布内容等。</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">（</span>1）您使用上传图片、发布音视频功能时，我们会请求您授权相机、照片、麦克风等敏感权限。您如果拒绝授权提供，将无法使用此功能，但不影响您正常使用“小程序”的其他功能。</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">（</span>2）您发布信息并选择显示位置时，我们会请求您授权地理位置这一敏感权限，并收集与本服务相关的位置信息。这些技术包括 IP 地址、GPS 以及能够提供相关信息的 WI-FI 接入点、蓝牙和基站等传感器技术。您如果拒绝授权提供，将无法使用此功能，但不影响您正常使用“小程序”的其他功能。</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">5.为您提供互动功能或服务</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">您主动关注您感兴趣的账号、话题并与之进行互动，进行评论或分享内容时，我们会收集您关注的账号，并向您展示您关注账号发布内容。</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">6.为您提供搜索服务</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">您使用</span><span style="font-family:宋体">“小程序”的搜索服务时，我们会收集您的搜索关键字信息、日志记录等。为了提供高效的搜索服务，部分前述信息会暂时存储在您的本地存储设备之中，并可向您展示搜索结果内容、搜索历史记录。</span></span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">7.开展营销活动</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">当您选择参加我们举办的有关营销活动时，根据活动需要您可提供姓名、通信地址、联系方式、银行账号等信息。这些信息可能包括个人敏感信息（如个人电话号码、银行账号等），是您收到转账或者礼品所必要的，如果您拒绝提供这些信息，我们将可能无法向您转账或发放礼品。</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">8.保障产品、服务及用户使用安全</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">为帮助我们更好地了解</span><span style="font-family:宋体">“小程序”及相关服务的运行情况，以便确保运行与提供服务的安全，我们可能记录网络日志信息，以及使用软件及相关服务的频率、崩溃数据、总体安装、使用情况、性能数据等信息。</span></span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">（一）我们可能从第三方获得的您的个人信息</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">用户因使用我们的产品或者服务而被我们收集的信息，例如其他用户发布的信息中可能含有您的部分信息（如：在评论、留言、发布图文、音视频中涉及到与您相关的信息）。</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">（二）收集、使用个人信息目的变更的处理</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">请您了解，随着我们业务的发展，可能会对</span><span style="font-family:宋体">“小程序”的功能和提供的服务有所调整变化。原则上，当新功能或服务与个性化推荐、发布信息、互动交流、搜索查询、注册认证等场景相关时，收集与使用的个人信息将与原处理目的具有直接或合理关联。在与原处理目的无直接或合理关联的场景下，我们收集、使用您的个人信息，会再次进行告知，并征得您的同意。</span></span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">（三）依法豁免征得同意收集和使用的个人信息</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">请您理解，在下列情形中，根据法律法规及相关国家标准，我们收集和使用您的个人信息无需征得您的授权同意：</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">（</span>1）与国家安全、国防安全直接相关的；</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">（</span>2）与公共安全、公共卫生、重大公共利益直接相关的</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">（</span>3）与犯罪侦查、起诉、审判和判决执行等直接相关的；</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">（</span>4）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">（</span>5）所收集的您的个人信息是您自行向社会公众公开的；</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">（</span>6</span><span style="font-family: 宋体;font-size: 14px">）</span><span style="font-family: 宋体;font-size: 14px">合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">（</span>7）根据您的要求签订或履行合同所必需的；</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">（</span>8）用于维护“小程序”软件及相关服务的安全稳定运行所必需的，例如发现、处置“小程序”软件及相关服务的故障；</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">（</span>9）为合法的新闻报道所必需的；</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">（</span>10）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">（</span>11）法律法规规定的其他情形。</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">&nbsp;</span><span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">（</span><span style="font-family:宋体">1</span></span><span style="font-family: 宋体;font-size: 14px">2</span><span style="font-family: 宋体;font-size: 14px">）当依托平台使用行为，披露用户对平台的评论评价等作为统计、总结报告展示及复杂时</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">特别提示您注意，如信息无法单独或结合其他信息识别到您的个人身份，其不属于法律意义上您的个人信息；当您的信息可以单独或结合其他信息识别到您的个人身份时或我们将无法与任何特定个人信息建立联系的数据与其他您的个人信息结合使用时，这些信息在结合使用期间，将作为您的个人信息按照本隐私政策处理与保护。</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">二、对</span> Cookie 和同类技术的使用</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">Cookie 和同类技术是互联网中的通用常用技术。当您使用“小程序”及相关服务时，我们可能会使用相关技术向您的设备发送一个或多个 Cookie 或匿名标识符，以收集和存储您访问、使用本产品时的信息。我们使用 Cookie 和同类技术主要为了实现以下功能或服务：</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">（一）保障产品与服务的安全、高效运转</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">我们可能会设置认证与保障安全性的</span> cookie 或匿名标识符，使我们确认您是否安全登录服务，或者是否遇到盗用、欺诈等不法行为。这些技术还会帮助我们改进服务效率，提升登录和响应速度。</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">（二）帮助您获得更轻松的访问体验</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">使用此类技术可以帮助您省去重复您填写个人信息、输入搜索内容的步骤和流程（例如：记录搜索历史）。</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">（三）为您推荐、展示、推送您可能感兴趣的内容或账号</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">我们可能会利用</span> Cookie 和同类技术（例如 Beacon、Proxy 等技术）了解您的偏好和使用习惯，进行咨询或数据分析，以改善产品服务及用户体验，并优化您对广告的选择。 我们承诺，我们不会将 Cookie 用于本隐私政策所述目的之外的任何其他用途。</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">三、我们如何存储个人信息</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">（一）信息存储的地点</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">我们依照法律法规的规定，将在境内运营过程中收集和产生的您的个人信息存储于中华人民共和国境内。目前，我们不会将上述信息传输至境外，如果我们向境外传输，我们将会遵循法律法规的规定，征求您的自主选择同意。</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">（二）存储期限</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">我们仅在为提供</span><span style="font-family:宋体">“小程序”及服务之目的所必需的期间内保留您的个人信息，例如，您发布的信息、评论、点赞等信息，在您未撤回、删除或未注销账号期间，我们会保留相关信息。超出必要期限后，我们将对您的个人信息进行删除或匿名化处理，但法律法规另有规定的除外。</span></span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">四、我们如何共享、转让、公开披露个人信息</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">（一）个人信息的共享、转让</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">我们不会向第三方共享、转让您的个人信息，除非经过您本人事先授权同意，或者共享、转让的个人信息是去标识化处理后的信息，且共享第三方无法重新识别此类信息的自然人主体。</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">1.在下列情况下，经过您的自主选择同意，我们可能会共享的个人信息</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">（</span>1）帮助您使用“小程序”账号登录第三方产品</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">当您使用</span><span style="font-family:宋体">“小程序”登录第三方产品时，经过您的明示同意，我们会将您的昵称、头像等信息与您登录的第三方产品共享。</span></span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">（</span>2）为实现程序化广告推送，我们可能会与广告合作伙伴共享去标识化或匿名化处理后的信息</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">我们可能与委托我们进行推广和广告投放的合作伙伴共享信息，但我们不会分享用于识别您个人身份的信息，例如您的姓名、身份证号等，仅会向这些合作伙伴提供难以识别您个人身份的用户画像标签及去标识化或匿名化后的信息，以帮助其在不识别您个人身份的前提下提升广告有效触达率。您可以拒绝我们向您推送程序化广告，但不影响您使用其他服务。</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">（</span>3）为实现特定功能而与业务合作伙伴共享</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">当软件服务提供商、智能设备提供商或系统服务提供商与我们联合为您提供服务时，例如您需要使用地理位置功能时，为实现这一功能，我们可能会收集您的位置信息及相关设备信息（例如硬件型号、操作系统版本号、国际移动设备身份识别码（</span>IMEI）、网络设备硬件地址（MAC）经过去标识化后并提供给前述提供商。</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">（</span>4）帮助您参加营销推广活动</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">当您选择参加我们举办的有关营销活动时，根据活动需要您提供</span><span style="font-family: 宋体;font-size: 14px">公司信息、</span><span style="font-family: 宋体;font-size: 14px">姓名、</span><span style="font-family: 宋体;font-size: 14px">职位、邮箱、</span><span style="font-family: 宋体;font-size: 14px">通信地址、联系方式、银行账号等信息。经过您的明示同意，我们会将上述信息与第三方共享以便我们能委托第三方及时向您提供奖品。</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">2.对共享个人信息第三方主体的谨慎评估及责任约束</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">（</span>1）经您同意，我们只会与第三方共享实现目的所必要的信息。如果第三方因业务需要，确需超出前述授权范围使用个人信息的，该第三方将需再次征求您的自主选择同意。</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">（</span>2）对我们与之共享您个人信息的第三方，该些第三方会与我们签订保密协议。同时，我们会对其数据安全能力与环境进行评估，并要求第三方以不低于本隐私政策所要求的保密和安全措施来处理该些信息。</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">3.收购、兼并、重组时个人信息的转让</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">随着我们业务的持续发展，我们将有可能进行合并、收购、资产转让，您的个人信息有可能因此而被转移。在发生前述变更时，我们将按照法律法规及不低于本隐私政策所要求的安全标准继续保护或要求个人信息的继受方继续保护您的个人信息，否则我们将要求继受方重新征得您的授权同意。</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">（二）个人信息的公开披露</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">我们不会公开披露您的信息，除非遵循国家法律法规规定或者获得您的自主选择同意。我们公开披露您的个人信息会采用符合行业内标准的安全保护措施，具体如下：</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">1. 对违规账号、欺诈行为进行处罚公告时，我们会披露相关账号的必要信息。</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">2.“寻人”、“追逃”等公益项目，经根据符合法律法规的明确授权后，我们会公开披露与事件相关的信息。当事件结束后，我们将及时删除已披露的个人敏感信息。</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">（三）依法豁免征得同意共享、转让、公开披露的个人信息</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">请您理解，在下列情形中，根据法律法规及国家标准，我们共享、转让、公开披露您的个人信息无需征得您的授权同意：</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">（</span>1）与国家安全、国防安全直接相关的；</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">（</span>2）与公共安全、公共卫生、重大公共利益直接相关的；</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">（</span>3）与犯罪侦查、起诉、审判和判决执行等直接相关的；</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">（</span>4）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">（</span>5）您自行向社会公众公开的个人信息；</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">（</span>6）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">五、我们如何保护个人信息安全</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">（一）我们非常重视您个人信息的安全，将努力采取合理的安全措施（包括技术方面和管理方面）来保护您的个人信息，防止您提供的个人信息被不当使用或未经授权的情况下被访问、公开披露、使用、修改、损坏、丢失或泄漏。</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">（二）我们会使用不低于行业同行的加密技术、匿名化处理等合理可行的手段保护您的个人信息，并使用安全保护机制防止您的个人信息遭到恶意攻击。</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">（三）我们会建立专门的安全部门、安全管理制度、数据安全流程保障您的个人信息安全。我们采取严格的数据使用和访问制度，确保只有授权人员才可访问您的个人</span> <span style="font-family:宋体">信息，并适时对数据和技术进行安全审计。</span></span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">（四）尽管已经采取了上述合理有效措施，并已经遵守了相关法律规定要求的标准，但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全，我们将尽力确保您提供给我们的个人信息的安全性。您知悉并理解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。因此，我们强烈建议您采取积极措施保护个人信息的安全，包括但不限于使用复杂密码、定期修改密码、不将自己的账号密码等个人信息透露给他人。</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">（五）我们会制定应急处理预案，并在发生用户信息安全事件时立即启动应急预案，努力阻止该等安全事件的影响和后果扩大。一旦发生用户信息安全事件（泄露、丢失等）后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已经采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以推送通知、邮件、信函、短信等形式告知您，难以逐一告知时，我们会采取合理、有效的方式发布公告。同时，我们还将按照相关监管部门要求，上报用户信息安全事件的处置情况。</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">（六）我们谨此特别提醒您，本隐私政策提供的个人信息保护措施仅适用于</span><span style="font-family:宋体">“小程序”及相关服务。一旦您离开“小程序”及相关服务，浏览或使用其他网站、服务及内容资源，我们即没有能力及义务保护您在“小程序”及相关服务之外的软件、网站提交的任何个人信息，无论您登录、浏览或使用上述软件、网站是否基于“小程序”的链接或引导。</span></span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">六、您的权利</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">我们非常重视您对个人信息的管理，并尽全力保护您对于您个人信息的访问、修改（更新或更正）、删除以及撤回授权同意的权利，以使您拥有充分的能力保障您的隐私和安全。</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">（一）访问、删除、更正您的个人信息</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">您可以通过以下方式管理您的信息：</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">您可以查询、访问、更正您的头像、用户名、简介、性别、生日、地区、位置、邮箱等基本信息（手机号信息除外），您可以在小程序的</span><span style="font-family:宋体">“设置”中进行查询、访问、更正。</span></span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">（二）自主选择控制个性化推荐信息</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">我们的相关信息推荐等功能可能会根据信息系统、算法等在内的非人工自动决策机制作出，当您对我们推送的信息不感兴趣或希望减少某些信息推荐时，您可以从设置</span>-我的商贸需求中更改您的标签设置。这会有助您对推送信息的控制与自主决策。</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">您也可以通过登录</span><span style="font-family:宋体">“小程序”客户端中的“反馈意见”页面入口与我们联系，您的反馈我们将会及时处理回复。</span></span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">（三）改变您授权同意范围或撤销授权</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">当您对我们推送的信息不感兴趣或希望减少某些信息推荐时，您可以在我的</span>-设置-我的商贸需求中更改您的标签信息。</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">（四）投诉举报</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">您可按照我们公示的制度进行投诉或举报。如果您认为您的个人信息权利可能受到侵害，或者发现侵害个人信息权利的线索（例如：认为我们收集您的个人信息违反法律规定或者双方约定），您可以通过点击</span><span style="font-family:宋体">“设置”-反馈意见，进入用户反馈界面与我们联系。我们核查后会及时反馈您的投诉与举报。</span></span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">（五）访问隐私政策</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">您可以在注册页面，或者在登录个人账号</span><span style="font-family:宋体">“</span></span><span style="font-family: 宋体;font-size: 14px">我的</span><span style="font-family: 宋体;font-size: 14px">”查看本隐私政策的全部内容。</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">（六）停止运营向您告知</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">如我们停止运营，我们将及时停止收集您个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，并对所持有的您的个人信息进行删除或匿名化处理。</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">七、未成年人条款</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">若您是未满</span> 18 周岁的未成年人，在使用“小程序”及相关服务前，应在您的父母或其他监护人监护、指导下共同阅读并同意本隐私政策。 我们根据国家相关法律法规的规定保护未成年人的个人信息，只会在法律允许、父母或其他监护人明确同意或保护未成年人所必要的情况下收集、使用、储存、共享、转让或披露未成年人的个人信息；如果我们发现在未事先获得可证实的父母同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关信息。 若您是未成年人的监护人，当您对您所监护的未成年人的个人信息有相关疑问时，请通过公司本隐私政策公示的联系方式与我们联系。</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">八、隐私政策的修订和通知</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">（一）为给您提供更好的服务，</span><span style="font-family:宋体">“小程序”及相关服务将不时更新与变化，我们会适时对本隐私政策进行修订，这些修订构成本隐私政策的一部分。</span></span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">（二）本隐私政策更新后，我们会在</span><span style="font-family:宋体">“小程序”发出更新版本，并在更新后的条款生效前通过官方网站公告或其他适当的方式提醒您更新的内容，以便您及时了解本隐私政策的最新版本，如您继续使用我们的服务，表示同意接受修订后的本政策的内容，但是如果更新的内容需要采集音视频、获取您通讯录、联系方式、地理位置等个人敏感信息，仍会再次以显著方式征求您的同意。</span></span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">（三）对于重大变更，我们还会提供更为显著的通知（我们会通过包括但不限于邮件、短信、私信或在浏览页面做特别提示等方式，说明《隐私政策》的具体变更内容）。</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">本《隐私政策》所指的重大变更包括但不限于：</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">（</span>1）我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息的类型、个人信息的使用方式等；</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">（</span>2）我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有变更等；</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">（</span>3）个人信息共享、转让或公开披露的主要对象发生变化；</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">（</span>4）您参与个人信息处理方面的权利及其行使方式发生重大变化；</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">（</span>5）我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时。</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">九、适用范围</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">本隐私权政策不适用于：</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">1. 其他第三方产品或服务，可能包括在个性化推荐中向您显示的产品或网站和广告内容或者“小程序”服务中链接到的其他产品或网站；</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">2. 为“小程序”服务进行广告宣传的其他第三方</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">您使用这些第三方服务（包括您向这些第三方提供的任何个人信息），将受这些第三方的服务条款及隐私政策约束（而非本隐私政策），具体规定请您仔细阅读第三方的条款。请您妥善保护自己的个人信息，仅在必要的情况下向第三方提供。</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">请您了解，本隐私政策中所述的</span><span style="font-family:宋体">“小程序”及相关服务可能会根据您所使用的手机型号、系统版本、软件应用程序版本、移动客户端等因素而有所不同。最终的产品和服务以您所使用的“小程序”软件及相关服务为准。</span></span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">如对本隐私政策内容有任何疑问、意见或建议，您可通过登录</span><span style="font-family:宋体">“小程序”客户端内的“反馈意见”页面口与我们联系。</span></span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">十、其他</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">（一）本</span><span style="font-family:宋体">“隐私政策”中的标题仅为方便及阅读而设，并不影响本《隐私政策》中任何规定的含义或解释。</span></span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">（二）本</span><span style="font-family:宋体">“隐私政策”相关词语释义：</span></span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">1.“小程序”及相关服务是指公司及其关联方通过合法拥有并运营的、标注名称为“小程序”的一些列客户端应用程序，向您提供的产品与服务，包括但不限于个性化推荐、发布信息、互动交流、搜索查询等核心功能以及其他功能，成为创作与交流的平台。</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">2.关联方是指，指一方现在或将来控制、受控制或与其处于共同控制下的任何公司、机构以及上述公司或机构的法定代表人。“控制”是指直接或间接地拥有影响所提及公司管理的能力，无论是通过所有权、有投票权的股份、合同或其他被依法认定的方式。</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">3.个人信息是指，以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息，包括个人身份信息（姓名、出生日期、身份证件号码，包括身份证、军官证、护照、驾驶证）、面部特征、地址、联系电话、通信录、网络身份识别信息（包括账号名、账号昵称、邮箱地址以及与前述有关的密码与密码保护问题和答案）；财产信息、交易信息、个人上网记录（网络浏览记录、点击记录等）、个人常用设备信息（包括硬件型号、设备 MAC 地址、操作系统类型、软件列表唯一设备识别码等在内的描述个人常用终端设备基本情况的信息）、个人位置信息等。</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">4.个人敏感信息是指，一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。本隐私政策中的个人敏感信息包括：包括个人身份信息（身份证件号码，包括身份证、军官证、护照、驾驶证）、面部识别特征；财产信息、交易信息；网络身份识别信息（包括账号名、账号昵称、邮箱地址以及与前述有关的密码与密码保护问题和答案）；其他信息（包括通信录、个人电话号码、行程信息、精准定位信息）。</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">5.去标识化是指，通过对个人信息的技术处理，使其在不借助额外信息的情况下，无法识别个人信息主体的过程。</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px">6.匿名化是指，通过对个人信息的技术处理，使得个人信息主体无法被识别，且处理后的信息不能被复原的过程。</span>
</p>
<p>
    <span style="font-family: 宋体;font-size: 14px"><span style="font-family:宋体">本</span><span style="font-family:宋体">“隐私政策”的版权为我们所有，在法律允许的范围内，我们拥有解释和修改的权利。</span></span>
</p>
<p>
    <br/>
</p>
      <div class="btn-box">
        <van-button type="primary" :color="mainColor" @click="hideMz"
          >确定</van-button
        >
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, computed } from 'vue'
import { useStore } from 'vuex'
const store = useStore()
const mainColor = computed(() => 'linear-gradient( 90deg, #02599F 0%, #55A972 70%,  #A1C98B 100%)');

const props = defineProps({
  modelValue: false
})
const checked = ref(props.modelValue)
const emit = defineEmits(['update:modelValue'])
const changeChecked = () => {
  emit('update:modelValue', checked.value)
}

const show = ref(false)
const showyhxy = ref(false)
const showxmyy = ref(false)
const showyx=ref(false)
const checkMz = () => {
  show.value = true
}
const checkyhxy = () => {
  showyhxy.value = true
}
const checksmyy=()=>{
  showxmyy.value = true
}
const checkys=()=>{
  showyx.value = true
}

const hideMz = () => {
  showyhxy.value = false
   showxmyy.value = false
   showyx.value = false
}
</script>
<style lang="less">
.mzbox {
  display: flex;
  justify-content: center;
  padding: 2vw 0;
}
.self-dia {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  overflow-y: auto;
}
.mz-block {
  width: 90vw;
  background: #fff;
  border-radius: 10px;
  padding: 5vw;
  margin: 5vw auto;
  // min-height: 170vh;
  h3 {
    font-size: 20px;
  }
  p {
   // text-indent: 2em;
    text-align: left;
    margin: 3vw 0;
  }
  .btn-box {
    border-radius: 8px;
    padding-top: 3vw;
  }
}
</style>
